import "./MemberHeader.css";

import logo from "../assets/icons/CDR-Logo.png";
import bellIcon from "../assets/icons/notification.png";

export default function MemberHeader() {
  return (
    <header className="member-header">
      <div className="member-header-container">
        <div className="header-logo-section">
          <img src={logo} alt="" className="header-logo" />

          <h2>MEMBER PORTAL</h2>
        </div>

        <div className="header-profile">
          <button className="notification-btn">
            <img src={bellIcon} alt="" />
          </button>

          <div className="profile-box">
            <div className="mh-avatar">JS</div>

            <div>
              <h4>John Smith</h4>
              <span>Professional Member</span>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
